import { ErrorHandler, Injectable, Injector, inject, signal } from '@angular/core';

export const fatalError = signal(false);

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // Injector used for lazy resolution to avoid circular init issues with ErrorHandler.
  private readonly injector = inject(Injector);

  handleError(error: unknown): void {
    console.error('[GlobalErrorHandler]', error);

    // The Angular DevTools browser extension injects a script into every page
    // and throws this when it can't attach to an optimized (staging/prod) build.
    // It's the extension failing to attach, not an app error — ignore it.
    const message = error instanceof Error ? error.message : String(error);
    if (message.includes('Angular DevTools')) {
      return;
    }

    if (typeof window !== 'undefined') {
      fatalError.set(true);
    }
  }
}
